// Setup the namespace for this logic
var forcePleaseWaitLB = forcePleaseWaitLB || {};


// If there are other "submit" calls to be made from the ap.page.onSubmit() function that could cause the submit 
//    to be aborted, perform those checks first, and this one after.  If you don't, the pleaseWaitLB may not be
//    properly closed.
forcePleaseWaitLB.submit = function(action) {
	if (action=='Continue') {
		ap.pleaseWaitLB(true);
	}
	return true;
};
